import { ADDONS, PRICE_MODEL } from '#common/constants/addons';

import icon from './assets/SWMBulkEdit.jpg';

import type { Addon } from '../types';

function Description() {
  return (
    <>
      <div>
        The <b>SWM</b> (S)mall (W)arehouse (M)anagement <b>Bulk Edit Module</b> enhances the SWM platform by providing below features:
      </div>
      <br />
      <div>
        For admins:
        <ul>
          <li>The admins can insert at the the begining/insert at the end/replace words to the <b>Title</b> to <b>multiple products</b> at a time.</li>
          <li>The admins can insert at the the begining/insert at the end/replace words to the <b>Description</b> to <b>multiple products</b> at a time.</li>
          <li>The admins can add/remove/replace multiple <b>Shipping Windows</b> to <b>multiple products</b> at a time.</li>
          <li>The admins can add/remove/replace multiple <b>Customizations</b> to <b>multiple products</b> at a time.</li>
          <li>The admins can assign multiple <b>products</b> to <b>multiple collections</b> at a time.</li>
          <li>The admins can delete multiple <b>products</b> at a time.</li>
        </ul>
      </div>
    </>
  );
}

const addon: Addon = {
  apply: () => {

  },
  info: {
    id: ADDONS.PRODUCT_BULK_EDIT,
    available: true,
    name: 'SWM Bulk Edit',
    version: '1.0',
    icon,
    descriptionText: 'SWM Bulk Edit module opens up the ability to edit multiple products at a time, provides the ease of editing product properties quickly and efficiently.',
    descriptionComponent: <Description />,
    priceModel: PRICE_MODEL.ONE_TIME_PURCHASE,
    price: 79.99,
  },
};

export { default as ProductBulkEditBar } from './ProductBulkEditBar';

export default addon;
